<template>
    <!--    This is set up to match the ORM-query version - the data is returned a bit differently -->
    <v-main>
        <v-container class="py-1">
            <v-row>
                <v-col class="py-0">
                    <v-tabs>
                        <v-tab @click="getAll()"><v-icon small class="pr-1">mdi-sticker-outline</v-icon>Marked Locations</v-tab>
                        <v-tab><v-icon small class="pr-1">mdi-clipboard-outline</v-icon>Playlists</v-tab>
                        <v-tab class="hidden-xs-only">Sides</v-tab>
                        <v-tab-item>
                            <Notes :height="height" :notes="notes"/>
                            <AddNote fab @close="" :tag="tag" :orgkey="org.partkey"/>
                        </v-tab-item>
                        <v-tab-item>
                            <Sessions :height="height"/>
                        </v-tab-item>
                        <v-tab-item  class="hidden-xs-only">
                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <Notes :height="height" :notes="notes"/>
                                    <AddNote fab @close="" :tag="tag" :orgkey="org.partkey"/>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <Sessions :height="height"/>
                                </v-col>
                            </v-row>
                        </v-tab-item>
                    </v-tabs>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import AddNote from "@/views/notes/AddNote";
  import Notes from "@/views/library/Notes"
  import Sessions from "@/views/library/Sessions";

  export default {
    name: "Index",
    components: {Notes, Sessions, AddNote},
    data() {
      return {
        view: 'notes',
        storedview: 'notes',
        notes: undefined,
        selected: undefined,
        capi: 'api/notes',
        tag: false
      }
    },
    computed: {
      ...mapState(['icons', 'org']),
      height() {
        console.log(window.innerHeight)
        return window.innerHeight - 150
      }
    },
    created() {
      this.getAll()
      let em=this
    },
    methods: {
      ...mapActions(['get', 'post']),
      async getAll() {
        this.notes = await this.get({path: this.capi + '/all'})
        console.log(this.notes)
      }
    }
  }

</script>

<style scoped>

</style>